export default __webpack_public_path__ + "media/images/brands/expmessenger/backgrounds/bg-03-0c0ad3653f4afb2c10ff23520dd3e29e.jpg";